import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as FreeChoiceOrderingMethod | null;

const slice = createSlice({
  name: '$freeChoiceOrderingMethod',
  initialState,
  reducers: {
    setFreeChoiceOrderingMethod(
      state,
      action: PayloadAction<FreeChoiceOrderingMethod | null>,
    ) {
      return action.payload;
    },
  },
});

export const { setFreeChoiceOrderingMethod } = slice.actions;
export default slice.reducer;
